(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desire-experience-timeline')) {
    customElements.define('desire-experience-timeline',class extends HTMLElement {
      connectedCallback() {
        if(this.controller)return;
        this.controller=new AbortController();
        const signal=this.controller.signal;
        this.tabs=[...this.querySelectorAll('.dt__tab')];
        this.panels=[...this.querySelectorAll('.dt__state')];
        this.track=this.querySelector('.dt__tabs');
        this.video=this.querySelector('video');
        this.motionButton=this.querySelector('.dt__motion');
        this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile=matchMedia('(max-width: 749px)');
        this.index=0;
        this.near=false;
        this.visible=false;
        this.userPaused=false;
        this.tabs.forEach((tab,i)=>tab.addEventListener('click',()=>this.select(i),{signal}));
        this.track.addEventListener('keydown',event=>{
          let next=this.index;
          if(event.key==='ArrowRight')next=(next+1)%this.tabs.length;
          else if(event.key==='ArrowLeft')next=(next-1+this.tabs.length)%this.tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=this.tabs.length-1;
          else return;
          event.preventDefault();this.select(next);this.tabs[next].focus();
        },{signal});
        this.addEventListener('shopify:block:select',event=>{
          const panel=event.target.closest('.dt__state');
          const i=this.panels.indexOf(panel);if(i>=0)this.select(i);
        },{signal});
        this.resizeObserver=new ResizeObserver(()=>this.positionPill());
        this.resizeObserver.observe(this.track);
        this.observer=new IntersectionObserver(entries=>{
          this.near=entries[0].isIntersecting;this.syncVideo();
        },{rootMargin:'250px'});
        this.observer.observe(this);
        this.visibilityObserver=new IntersectionObserver(entries=>{
          this.visible=entries[0].isIntersecting;this.syncVideo();
        },{threshold:.05});
        this.visibilityObserver.observe(this);
        this.reduced.addEventListener('change',()=>this.syncVideo(),{signal});
        this.mobile.addEventListener('change',()=>this.syncVideo(),{signal});
        document.addEventListener('visibilitychange',()=>this.syncVideo(),{signal});
        this.motionButton?.addEventListener('click',()=>{
          this.userPaused=!this.userPaused;
          this.motionButton.setAttribute('aria-pressed',String(this.userPaused));
          this.motionButton.setAttribute('aria-label',this.userPaused?this.motionButton.dataset.play:this.motionButton.dataset.pause);
          this.syncVideo();
        },{signal});
        this.video?.addEventListener('playing',()=>this.classList.add('is-playing'),{signal});
        this.video?.addEventListener('error',()=>this.classList.remove('is-playing'),{signal});
        this.select(0);this.syncVideo();
        document.fonts?.ready.then(()=>{if(this.isConnected)this.positionPill();});
      }
      select(index) {
        if(!this.tabs[index])return;
        this.index=index;
        this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        this.panels.forEach((panel,i)=>{panel.classList.toggle('is-active',i===index);panel.setAttribute('aria-hidden',String(i!==index));panel.inert=i!==index;});
        this.style.setProperty('--dt-tint',this.panels[index].dataset.tint);
        this.positionPill();
      }
      positionPill() {
        const tab=this.tabs[this.index];if(!tab)return;
        this.track.style.setProperty('--pill-x',tab.offsetLeft+'px');
        this.track.style.setProperty('--pill-width',tab.offsetWidth+'px');
      }
      syncVideo() {
        const staticMode=this.reduced.matches||document.body.dataset.motion==='false'||this.dataset.autoplay==='false';
        this.toggleAttribute('data-static',staticMode);
        if(this.motionButton)this.motionButton.hidden=staticMode;
        if(!this.video)return;
        if(staticMode){this.video.pause();this.classList.remove('is-playing');return;}
        const source=this.mobile.matches?this.video.dataset.mobile:this.video.dataset.desktop;
        if(this.near&&source&&this.video.getAttribute('src')!==source){
          this.classList.remove('is-playing');this.video.src=source;this.video.muted=true;this.video.load();
        }
        if(this.visible&&!document.hidden&&!this.userPaused&&source){this.video.play().catch(()=>{});}
        else this.video.pause();
      }
      disconnectedCallback() {
        this.controller?.abort();this.controller=null;
        this.resizeObserver?.disconnect();this.observer?.disconnect();this.visibilityObserver?.disconnect();this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
